/* eslint-disable vue/component-definition-name-casing */
/* eslint-disable vue/multi-word-component-names */
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
